import _styled from "styled-components";
import React from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import * as styles from "./SkeletonLabel.styles";
var text = theme.text;
export var SkeletonLabel = function SkeletonLabel(_ref) {
  var className = _ref.className,
    height = _ref.height,
    _ref$labelHeight = _ref.labelHeight,
    labelHeight = _ref$labelHeight === void 0 ? 'MD' : _ref$labelHeight,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'regular' : _ref$variant;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    style: {
      height: pxToRem(height || text.HEADING[labelHeight].fontSize)
    },
    $_css: styles[variant]
  });
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "SkeletonLabel___StyledDiv",
  componentId: "sc-ocv6q9-0"
})(["", ""], function (p) {
  return p.$_css;
});